<template>
  <div>
    <vue-element-loading :active="isLoading" is-full-screen  text="Please wait..." />
    <div class="report-box">
        <table  style="height:200px;">
            <vue-element-loading :active="isLoading1"  text="Please wait..." />
            <tr>
                <td colspan="5">
                    <div>
                        <img :src="stft_image" />
                    </div>
                </td>
                <td colspan="6" style="padding-left:30px;width:300px;">
                    <div>
                        <span class="title font-size">{{$t("time_interval")}}: </span>
                        <span>{{ sec_txt }} sec</span>
                        <b-dropdown left :text="hz_text1" variant="outline-secondary" style="margin-left:100px;">
                            <b-dropdown-item v-for="(item, index) in stft_hz" :key="index" @click="chageStftValue(index)">{{ item }} Hz</b-dropdown-item>
                        </b-dropdown>
                        <span><b-button variant="outline-secondary" @click="downloadSTFTCSV" style="margin-left:20px;">EXPO</b-button></span>
                    </div>
                    <div style="margin-top:10px;width:400px;height:400px;display:block;overflow-y:auto;">
                        <table class="table table-hover" style="text-align:center;">
                            <thead>
                                <tr>
                                    <th scope="col" style="text-align:center;">Sec</th>
                                    <th scope="col" style="text-align:center;">Value</th>
                                    <th scope="col" style="text-align:center;">Color</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in reportData" :key="index">
                                    <td style="vertical-align:middle;">
                                        {{item.sec}}
                                    </td>
                                    <td style="vertical-align:middle;">
                                        {{item.value}}
                                    </td>
                                    <td style="vertical-align:middle;">
                                        {{item.color}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </td>
            </tr>
        </table>
    </div>
    <div class="report-box" style="margin-top:40px;">
        <!-- <vue-element-loading :active="isLoading4"  text="Please wait..." /> -->
        <div class="font-size">
            <span class="title">{{$t("time_interval")}}: </span>
            <span>{{ sec_txt }} sec</span>
            <span class="title" style="margin-left:30px;">{{$t("time_filter")}}: </span>
            <span><input type="text" style="width:100px;height:35px;" v-model.number="start_value"/></span>
            <span class="title" style="font-size:22px;">~</span>
            <span><input type="text" style="width:100px;height:35px;" v-model.number="end_value"/></span>
            <span style="margin-left:10px;"><b-button variant="outline-secondary"  @click="getReportSTFTMean">{{$t("sure")}}</b-button></span>
        </div>
        <div style="margin-top:10px;">
            <table class="table">
                <thead>
                    <tr>
                        <th></th>
                        <th v-for="(item, index) in stft_hz" :key="index">{{item}} HZ</th> 
                    </tr>
                </thead>
                <tbody>
                    <td class="title">{{$t("txt_7")}}</td>
                    <td v-for="(item, index) in stftMean1" :key="index">{{ item }}</td>
                </tbody>
            </table>
        </div>
        <div class="report-box" style="margin-top:40px;">
            <table class="table">
                <thead>
                    <tr>
                        <th></th>
                        <th>{{$t("txt_8")}}</th> 
                        <th>{{$t("txt_9")}}</th> 
                        <th>{{$t("txt_10")}}</th> 
                        <th>{{$t("txt_11")}}</th> 
                    </tr>
                </thead>
                <tbody>
                    <td class="title">{{$t("txt_12")}}</td>
                    <td v-for="(item, index) in stftMean2" :key="index">{{ item }}</td>
                </tbody>
            </table>
        </div>
        <div style="margin-top:40px;">
            <b-dropdown left :text="hz_text" variant="outline-secondary">
                <b-dropdown-item v-for="(item, index) in stft_hz" :key="index" @click="chageStftValue1(index)">{{ item }} Hz</b-dropdown-item>
            </b-dropdown>
            <table class="table" style="margin-top:10px;">
                <thead>
                    <tr>
                        <th>{{hz_text}}</th>
                        <th>尺({{timeData[0][0]}}~{{timeData[0][1]}}ms)</th>
                        <th>關({{timeData[1][0]}}~{{timeData[1][1]}}ms)</th>
                        <th>寸({{timeData[2][0]}}~{{timeData[2][1]}}ms)</th>
                    </tr>
                </thead>
                <tbody>
                    <td class="title">Value(max)</td>
                    <td v-for="(item, index) in maxData" :key="index">{{ item }}</td>
                </tbody>
            </table>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props: ["type"],
    data() {
        return {
            report_id: '',
            nperseg: 36,
            hz_length: 11,
            sec_txt: '0.1',
            start_value: '100',
            end_value: '500',
            reportData: [],
            stftMean1: [],
            stftMean2: [],
            timeData: [],
            maxData: [],
            stft_image: '',
            hz_text: '0Hz',
            hz_text1: '0Hz',
            stft_hz: ['0','5','10','15','20','25','30','35','40','45','50'],
            isLoading: false,
            isLoading1: false,
            // isLoading4: false,
        }
    },
    created(){
        const report = JSON.parse(sessionStorage.getItem('client_report'));
        this.report_id = report.id;
        
        if(this.type == 1){
            this.stft_hz = ['0','5','10','15','20','25','30','35','40','45','50'];
            this.nperseg = 36;
            this.hz_length = 11;
            this.sec_txt = '0.1';
            this.start_value = 100;
            this.end_value = 500;
        }else{
            this.stft_hz = ['0','10','20','30','40','50'];
            this.nperseg = 18;
            this.hz_length = 6;
            this.sec_txt = '0.05';
            this.start_value = 50;
            this.end_value = 500;
        }
        this.getReportSTFT(0);
        this.getReportSTFTMean();
        this.getReportSTFTMaxValues(0);
    },
    methods: {
        getReportSTFTImage(){
            const api = `${process.env.VUE_APP_APIPATH}/client/report/stft/img`;
            const json = {
                report_id: this.report_id,
                client_account: 'test',
                nperseg: this.nperseg,

            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    this.stft_image = res.data.data;
                    this.isLoading1 = false;
                }
            })
        },
        getReportSTFT(index) {
            this.isLoading1 = true;
            const api = `${process.env.VUE_APP_APIPATH}/client/report/stft`;
            const json = {
                report_id: this.report_id,
                nperseg: this.nperseg,
                hz_index: index
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    this.reportData = res.data.data;
                    this.getReportSTFTImage();
                }
            })
        },
        getReportSTFTMean() {
            this.isLoading = true;
            const api = `${process.env.VUE_APP_APIPATH}/client/report/stft/mean`;
            const json = {
                report_id: this.report_id,
                nperseg: this.nperseg,
                hz_length: this.hz_length,
                start_value: this.start_value,
                end_value: this.end_value
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    this.stftMean1 = res.data.data[0].mean_value1;
                    this.stftMean2 = res.data.data[0].mean_value2;
                }else{
                    alert(this.$t("nperseg_no_data"))
                    if(this.type == 1){
                        this.start_value = 100;
                        this.end_value = 500;
                    }else{
                        this.start_value = 50;
                        this.end_value = 500;
                    }
                    
                    this.getReportSTFTMean();
                }
                this.isLoading = false;
            })
        },
        downloadSTFTCSV() {
            this.isLoading = true;
            const api = `${process.env.VUE_APP_APIPATH}/client/report/stft/csv`;
            const json = {
                report_id: this.report_id,
                client_account: 'test',
                nperseg: this.nperseg,

            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    const url = res.data.data;
                    window.open(url, '_blank')
                    this.isLoading = false;
                }
            })
        },
        getReportSTFTMaxValues(index) {
            this.isLoading = true;
            const api = `${process.env.VUE_APP_APIPATH}/client/report/stft/sec/max`;
            const json = {
                report_id: this.report_id,
                nperseg: this.nperseg,
                hz_index: index
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    this.timeData = res.data.data.time;
                    this.maxData = res.data.data.max;
                    this.isLoading = false;
                }
            })
        },
        chageStftValue(index) {
            this.hz_text1 = this.stft_hz[index] + 'Hz'
            this.getReportSTFT(index);
            // this.getReportSTFTMean();
            this.getReportSTFTImage();
        },
        chageStftValue1(index) {
            this.hz_text = this.stft_hz[index] + 'Hz'
            this.getReportSTFTMaxValues(index);
        }
    }
}
</script>
